export const environment = {
  production: true,
  url: "https://aqueous-peak-57304.herokuapp.com"
};
